/// <reference path="../shared/return-object.model.ts" />
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ImageLibraryService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'ImageLibrary';

    addNewImage(category: string, imageName: string): Observable<IReturnObject> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let postUrl = `${this.apiUrl}/AddNewImage?category=${category}&imageName=${imageName}.jpg`;

        return this.http.post(postUrl, null)
            .map((response: Response) => <IReturnObject>response.json());
    }

    
    getImagesByLabels(labels: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetImagesByLabels/?labels=${labels}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getImageLabels(searchString: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetImageLabels/?searchString=${searchString}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteImage(imageId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteImageFromLib/?imageId=${imageId}`)
            .map((response: Response) => <IReturnObject>response.json());

    }

}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/image-library/image-library.service.ts